import { CloudDownloadOutlined } from '@ant-design/icons'
import { triggerReservationsExport } from '@services/ReservationService'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { App, Button } from 'antd'
import { FC, useState } from 'react'
import { DEFAULT_ERROR } from '../../App'
import { Permission } from '../../utils/permissions'
import { useHasAccess } from '../HasAccess'

type Props = {
  query?: TableParams
}

const ReservationExportReservations: FC<Props> = ({ query }) => {
  const { message } = App.useApp()
  const { hasAccess } = useHasAccess()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  if (!hasAccess(Permission.manageBusiness)) {
    return <></>
  }

  const onClick = () => {
    if (!query) return

    setIsLoading(true)
    triggerReservationsExport(query)
      .then(() => {
        message.success(
          'Reservations export successfully queued! You will receive it by email once available.'
        )
      })
      .catch(() => {
        message.error(DEFAULT_ERROR)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <Button
      type="primary"
      onClick={onClick}
      loading={isLoading}
      icon={<CloudDownloadOutlined />}
    >
      Export to csv
    </Button>
  )
}

type ReservationExportReservationsType = {
  ExportReservations: typeof ReservationExportReservations
}

export { ReservationExportReservations, type ReservationExportReservationsType }
